import 'antd/es/layout/style';

import { useLocalStorageState, useRequest, useTitle } from 'ahooks';
import { Breadcrumb, Flex, Layout, Menu, Space, Watermark } from 'antd';
import React, { Suspense, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { matchPath, useLocation } from 'react-router';
import { Link, Outlet, useNavigate } from 'react-router-dom';
import Header from './header'
import allRoutes from '@/routes';
import useGetAuthRoutes from '@/routes/auth-routes';


import styles from './index.module.less';
import { useUserInfo } from '@joyu/auth';
import dayjs from 'dayjs';
import useStore from '@/hooks/use-store';

interface BreadcrumbItem {
  path: string;
  name: string;
  key: string;
}

const { Sider, Content } = Layout;
const { SubMenu } = Menu;

const CustomLayout = () => {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useTranslation();
  const {
    setSubAppAvatarFunctions
  } = useStore()

  // 如果没有登录，跳转登录页
  const [token] = useLocalStorageState(`JOY_ADMIN_${import.meta.env.VITE_APP_ENV}_TOKEN`, {
    defaultValue: '',
  });
  const { mainUserInfo } = useUserInfo();
  // useEffect(() => {
  //   if (!token && window.location.href.indexOf('login') < 0) {
  //     navigate(`/login?redirect=${window.location.pathname}${window.location.search}`);
  //   }
  // }, [navigate, token]);
  useTitle('欢乐互娱研发工具平台');

  // 处理进来时展开的菜单
  const locationStr = useLocation().pathname;
  // 处理面包屑导航
  const breadcrumbList: Array<BreadcrumbItem> = [];
  const { defaultSelectedKeys, defaultOpenKeys } = useMemo(() => {
    // 处理进来时展开的菜单
    const defaultSelectedKeys: string[] = [];
    let defaultOpenKeys: string[] = [];
    for (let i = 0; i < allRoutes.length; i++) {
      const firstGrade = allRoutes[i];
      if (firstGrade.path === '*') continue;
      if (firstGrade.children && firstGrade.children.length) {
        for (let j = 0; j < firstGrade.children.length; j++) {
          const secondGrade = firstGrade.children[j];
          if (secondGrade.path === '*') continue;
          const match = matchPath({ path: secondGrade.path, end: false }, locationStr);
          if (match) {
            const currentFirstPath = firstGrade.path ? firstGrade.path.toLocaleString() : '';
            if (secondGrade?.path && !secondGrade?.hidden) {
              defaultSelectedKeys.push(secondGrade.path);
            }
            defaultOpenKeys = [locationStr === '/dashboard' ? '' : currentFirstPath];
          }
        }
      } else {
        const match = matchPath(firstGrade.path, locationStr);
        if (match) {
          const currentFirstPath = firstGrade.path ? firstGrade.path.toLocaleString() : '';
          if (firstGrade?.path && !firstGrade?.hidden) {
            defaultSelectedKeys.push(firstGrade.path);
          }
          defaultOpenKeys = [currentFirstPath];
        }
      }
    }
    return {
      defaultSelectedKeys,
      defaultOpenKeys,
    };
  }, [locationStr]);

  // 折叠展开方法
  const toggleCollapse = useCallback(() => {
    setCollapsed(!collapsed);
  }, [collapsed]);

  const { menuList } = useGetAuthRoutes();

  return (
    <Watermark
      font={{
        color: '#efefef66',
        fontSize: 24,
      }}
      content={[
        `${mainUserInfo.username} ${mainUserInfo.email}`,
        dayjs().format('YYYY-MM-DD HH:mm:ss'),
      ]}
    >
      <Layout className={styles['layout-container']}>
        <Header />
        <Content className={styles.content}>
          <Suspense fallback="loading...">
            <Outlet />
          </Suspense>
        </Content>
      </Layout>
    </Watermark>
  );
};
export default React.memo(CustomLayout);
